import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import Row, { Slot } from './row'
import Button from './button'
import styles from '../component-styles/plan-card.module.scss'
import openPaddle, { getPaddlePrice } from '../paddle-client/paddle'
import { getPaddleData } from '../local-client/local-client'

interface Props {
  plan: {
    planType: 'solo' | 'collaboration'
    price: number
    id: number
  }
  style?: any
}

const plans = {
  solo: {
    slug: 'solo',
    planName: 'SOLO',
    price: 0,
    features: ['All features', '1 user', 'Email support'],
  },
  collaboration: {
    slug: 'collaboration',
    planName: 'COLLABORATION',
    price: 0,
    features: ['All features', 'Unlimited users', 'Account manager support'],
  },
}

export default function PlanCard({
  plan,
  style,
}: Props): React.ReactElement | null {
  const [price, setPrice] = useState('')
  const history = useHistory()
  const { paddleData } = useSelector((s: any): any => s.onboarding)
  const { details } = useSelector((s: any): any => s.user)
  const { selected: selectedSite } = useSelector((s: any): any => s.site)

  useEffect(() => {
    if (plan?.id) {
      getPaddlePrice({
        productId: plan.id,
        setPrice,
      })
    }
  }, [plan])

  if (!plan) return null

  const {
    // slug,
    planName,
    features,
  } = plans[plan.planType]

  const handleClick = () => {
    let passthroughData = {}

    if (Object.keys(paddleData).length === 0) {
      const localPaddleData = getPaddleData()
      if (
        !localPaddleData ||
        (localPaddleData && Object.keys(localPaddleData).length === 0)
      ) {
        // This gets used on screen refresh OR when restarting the payment journey
        let loadedData = {}
        if (details && details.uid && selectedSite && selectedSite.companyID) {
          const { uid: userID, runningDebug: test } = details
          const { companyID: compID } = selectedSite
          loadedData = {
            userID,
            test,
            compID,
          }
        }
        // none of the data is available, do the redirect to create-account page
        if (Object.keys(loadedData).length === 0) {
          history.push('/create-account')
          return
        }
        passthroughData = loadedData
      } else {
        passthroughData = localPaddleData
      }
    } else {
      passthroughData = paddleData
    }

    openPaddle({
      productId: plan.id,
      email: details?.email,
      passthrough: JSON.stringify(passthroughData),
    })
  }

  return (
    <div
      className={styles.card}
      style={style}
      onClick={handleClick}
      onKeyDown={handleClick}
      role="button"
      tabIndex={-1}
    >
      <div className={styles.copyContainer}>
        <Row>
          <Slot align="flex-start" width={112}>
            <p className={styles.planName}>{planName}</p>
          </Slot>
          <Slot align="flex-end">
            <p className={styles.pricing}>
              <span className={styles.price}>{price}</span>
              <span className={styles.perWebsite}>per website</span>
            </p>
          </Slot>
        </Row>
        <Row>
          <Slot>
            <ul className={styles.list}>
              {features.map(
                (feature: string): React.ReactElement => (
                  <li key={feature}>{feature}</li>
                ),
              )}
            </ul>
          </Slot>
        </Row>
      </div>
      <Row>
        <Slot>
          <Button type="flatRed">Select Plan</Button>
        </Slot>
      </Row>
    </div>
  )
}
